module.exports = __webpack_public_path__ + "static/media/fee report icon.a68443f5.svg";